import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteLayout } from "@/components/site/Layout";
import { Section } from "@/components/site/Section";

const title = "Kristan Cole Network SMS Terms & Conditions";
const description =
  "Terms and conditions for Kristan Cole Network SMS communications, including consent, message frequency, rates, opt-out, and help information.";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
    ],
    links: [{ rel: "canonical", href: "https://joinkcn.com/terms" }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <SiteLayout>
      <section className="bg-background">
        <div className="container-edge">
          <div className="max-w-3xl mx-auto pt-32 md:pt-40 pb-8">
            <p className="eyebrow text-foreground/70 mb-6">Legal</p>
            <h1 className="font-display font-light tracking-[-0.02em] leading-[1.05] text-[clamp(2.25rem,4vw,3.5rem)]">
              Kristan Cole Network SMS Terms &amp; Conditions
            </h1>
          </div>
        </div>
      </section>

      <Section tone="dark" className="!pt-4 !pb-12 md:!pb-16">
        <div className="max-w-3xl mx-auto prose-legal">
          <p>
            <strong>Program:</strong> Kristan Cole Network SMS Communications
          </p>
          <p>
            Kristan Cole Network, a DBA of Cole Investments Inc., may send SMS
            messages to individuals who have consented to receive text
            communications from us.
          </p>
          <p>
            Messages may include appointment confirmations, scheduling
            information, appointment reminders, responses to inquiries, and
            related follow-up communications.
          </p>

          <p>
            <strong>Consent:</strong> SMS messages are sent only after the
            recipient has provided consent to receive text communications.
            Consent to receive SMS messages is not a condition of scheduling an
            appointment or receiving other services.
          </p>

          <p>
            <strong>Message Frequency:</strong> Message frequency varies based
            on your interaction with Kristan Cole Network and appointment
            activity.
          </p>

          <p>
            <strong>Message and Data Rates:</strong> Message and data rates may
            apply depending on your mobile carrier and service plan.
          </p>

          <p>
            <strong>Opt Out:</strong> Reply STOP to stop receiving SMS messages.
          </p>

          <p>
            <strong>Help:</strong> Reply HELP for assistance. You may also
            contact Kristan Cole Network at{" "}
            <a href="tel:+19073733575" className="text-primary hover:underline">
              907-373-3575
            </a>{" "}
            or{" "}
            <a
              href="mailto:support@thekristancolenetwork.com"
              className="text-primary hover:underline"
            >
              support@thekristancolenetwork.com
            </a>
            .
          </p>

          <p>
            After opting out, you will no longer receive SMS messages from this
            program unless you subsequently provide valid consent to receive
            them again.
          </p>

          <p>Carriers are not liable for delayed or undelivered messages.</p>

          <p>
            For information about how Kristan Cole Network collects and uses
            personal information, please review our Privacy Policy at{" "}
            <Link to="/privacy" className="text-primary hover:underline">
              joinkcn.com/privacy
            </Link>
            .
          </p>
        </div>
      </Section>
    </SiteLayout>
  );
}